module.exports = __webpack_public_path__ + "img/ic_mapsmarker.3f61080d.svg";